import React, { useCallback, useContext, useMemo, useState } from 'react';
import { Alert } from '@this/shared/ui/feedbacks/alert';
import { Button } from '@this/shared/ui/inputs/button';
import CoreAppContext from '@this/components/core_app/core_app_context';

const SlackIntegrationAlert: React.FC = () => {
  const { user } = useContext(CoreAppContext);

  const [slackNotificationDismissed, setSlackNotificationDismissed] = useState<boolean>(() => {
    return typeof window !== 'undefined' && localStorage.getItem('chatSlackNotificationDismissed') === 'true';
  });
  const userSlackConnected = useMemo(() => !!user?.aiTravelSlackToken, [user]);

  const handleDismissSlackNotification = useCallback(() => {
    localStorage.setItem('chatSlackNotificationDismissed', 'true');
    setSlackNotificationDismissed(true);
  }, []);

  const shouldShowSlackAlert = useMemo(
    () => user?.useSlackApp && !userSlackConnected && !slackNotificationDismissed,
    [user?.useSlackApp, userSlackConnected, slackNotificationDismissed]
  );

  if (!shouldShowSlackAlert) {
    return null;
  }

  return (
    <Alert
      variant="info"
      title="Slack連携のお知らせ"
      onClose={handleDismissSlackNotification}
      style={{ marginBottom: '20px' }}
    >
      <div style={{ marginBottom: '8px' }}>Slack連携を行うと、チャットの返信をSlackで受け取ることができます。</div>
      <Button onClick={() => window.open('/slackapp/ai_travel/start_slack_auth', '_blank', 'noopener,noreferrer')}>
        Slackと接続する
      </Button>
    </Alert>
  );
};

export default SlackIntegrationAlert;
